import React from 'react'
import styles from './styles.module.scss'
import moment from 'moment'
import IcDelete from 'emailThreadViewer/icons/IcDelete'
import classNames from 'classnames'
import IFace from 'emailThreadViewer/ViewerIFace'
import { Checkbox, Tooltip } from 'antd'
import IcOverdue from 'emailThreadViewer/icons/IcOverdue'
import IcDone from 'emailThreadViewer/icons/IcDone'
import IcRequested from 'emailThreadViewer/icons/IcRequested'
import i18n from 'i18n'
import NameOrEmail from './NameOrEmail'

type TaskStatus = 'completed' | 'overdue' | 'requested'

interface Assignee {
  name?: string | null
  email?: string | null
}

interface TaskItem {
  id: string
  start_date?: string
  due_date?: string | null
  complete_date?: string | null
  task_status: TaskStatus
  is_assigned_me?: boolean
  assignee?: Assignee[]
  subject: string
  body?: string
  allow_edit?: boolean
}

interface TasksProps {
  tasks?: TaskItem[]
  mailId: string
}

interface TaskProps {
  mailId: string
  task: TaskItem
}

const Tasks: React.FC<TasksProps> = ({ tasks, mailId }) => {
  if (!tasks?.length) return null

  return (
    <div>
      {tasks.map((task, idx) => (
        <Task mailId={mailId} task={task} key={`${mailId}-${idx}-${task.id}`} />
      ))}
    </div>
  )
}

const Task: React.FC<TaskProps> = ({ mailId, task }) => {
  const {
    id,
    // start_date: startDate,
    due_date: dueDate,
    complete_date: completeDate,
    task_status: taskStatus,
    // is_assigned_me: isAssignedMe,
    assignee,
    subject,
    // body,
    allow_edit,
  } = task
  const { dateFormat } = IFace.getTimeFormats()

  const formattedDate =
    taskStatus === 'completed' && completeDate
      ? moment(completeDate).format(dateFormat)
      : dueDate
        ? moment(dueDate).format(dateFormat)
        : null

  const handleDelete = (): void => IFace.WebToNative.changeTaskStatus(mailId, id, 'ignore')

  const handleCheckBoxClick = (e: any): void => {
    if (!allow_edit) return

    const checked = e.target.checked
    checked
      ? IFace.WebToNative.changeTaskStatus(mailId, id, 'completed')
      : IFace.WebToNative.clearTaskStatus(mailId, id)
  }

  return (
    <div className={classNames(styles.taskItem)}>
      <div className={classNames(styles.symbolContainer, styles.taskStatusCheckBoxContainer)}>
        <span className={styles.taskStatusIcon}>{StatusIcon[taskStatus]}</span>
        <Checkbox
          className={styles.taskCheckBox}
          checked={taskStatus === 'completed'}
          onChange={handleCheckBoxClick}
          disabled={!allow_edit}
        />
      </div>
      <div className={styles.taskContent}>
        <span className={styles.taskSubject}>
          {subject}
          {formattedDate && (
            <>
              {/* taskSubject를 한줄로 묶어서 줄바꿈 처리 대응
                내용/날짜/담당자 자연스러운 줄바꿈 처리와 간격 설정을 위해 공백으로 처리 */}
              <> &nbsp;</>
              <span className={styles.taskDate} data-task-status={taskStatus}>
                {formattedDate}
              </span>
            </>
          )}
          {assignee?.map(({ name, email }, idx) => (
            <React.Fragment key={`${name}-${email}`}>
              {idx === 0 && <> &nbsp;</>}
              <NameOrEmail name={name} email={email} />
              {idx !== assignee.length - 1 && <>, </>}
            </React.Fragment>
          ))}
        </span>

        <Tooltip title={i18n.t('email.aiExtraction.delete')}>
          <button className={styles.iconButton} onClick={handleDelete}>
            <IcDelete />
          </button>
        </Tooltip>
      </div>
    </div>
  )
}

const StatusIcon: Record<TaskStatus, React.ReactElement> = {
  completed: <IcDone />,
  overdue: <IcOverdue />,
  requested: <IcRequested />,
}

export default Tasks
